<template>
	<v-app class="noOverflow">
		<v-main class="v1 noOverflow" id="maincontainer">
			<v-fade-transition>
				<router-view />
			</v-fade-transition>
			<VuexSnackbar />
		</v-main>
	</v-app>
</template>

<script>
import VuexSnackbar from './components/VuexSnackbar.vue';
export default {
	components: { VuexSnackbar },
	mounted() {
		//Enable window debug if in development
		let devmode = process.env.NODE_ENV === 'development';
		window.enable_debug = {
			announcements: devmode,
			keystrokes: devmode,
		};
		if (window.enable_debug)
			console.info('DEBUG ENABLED BECAUSE DEVELOPMENT MODE');

		this.$store.dispatch('loadFromLocalStorage');
		this.clearDisableCameraODB();

		window.addEventListener('keydown', (e) => {
			if (e.key === 'd' || e.key === 'D') {
				let status = this.$store.state.DisableCameraODB;
				this.$store.dispatch('set_disablecameraodb', status ? null : Date.now());
				window.$snackbar(
					`Camera ODB ${status ? 'Enabled' : 'Disabled for 8 hours'}`
				);
			}
		});

		setTimeout(() => {
			if (this.$route.query.useDev) {
				if (this.$route.query.useDev != 'false') {
					//If the state of devmode is changing reload
					if (!localStorage.useDev) {
						window.$snackbar('Turning on useDev...');
						setTimeout(() => {
							window.location.reload();
						}, 200);
					}
					localStorage.useDev = true;
				} else {
					//If the state of devmode is changing reload
					if (localStorage.useDev) {
						window.$snackbar('Turning off useDev...');
						setTimeout(() => {
							window.location.reload();
						}, 200);
					}
					delete localStorage.useDev;
				}
			}
		}, 1000);
		this.clearODBTimer();
	},
	methods: {
		clearODBTimer() {
			setTimeout(() => {
				this.clearDisableCameraODB();
				//Check every 5 minutes if the camera ODB setting has expired
			}, 5 * 60 * 1000);
		},
		clearDisableCameraODB() {
			//Check if the camera ODB setting has expired (8 hours)
			if (this.$store.state.DisableCameraODB) {
				let now = Date.now();
				let enabledAt = this.$store.state.DisableCameraODB;
				let eightHours = 8 * 60 * 60 * 1000;
				if (now - enabledAt > eightHours) {
					this.$store.dispatch('set_disablecameraodb', null);
				}
			}
		},
	},
};
</script>

<style>
.v1 {
	/* background: rgb(71, 70, 66); */
}
</style>
<style>
html {
	overflow-y: hidden !important;
}
</style>
